import { fg } from '@atlassian/jira-feature-gating';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import ErrorPagesNotFound from '@atlassian/jira-router-routes-common/src/ui/error-pages/not-found/index.tsx';
import { assetsDataManagerDataSourceRoute } from '@atlassian/jira-router-routes-assets-data-manager-routes/src/assetsDataManagerDataSourceRoute.tsx';
import { createChromelessEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';
import {
	toPackageName,
	APP_NAMES,
} from '@atlassian/jira-servicedesk-common/src/utils/app-names/index.tsx';
import { getAssetsAppResources } from '@atlassian/jira-router-routes-servicedesk-cmdb-entries/src/common/getCmdbResources.tsx';
import { LazyAssetsLayout, AssetsLayout } from '@atlassian/jira-assets-layout/src/ui/async.tsx';
import { AssetsPageConfigContainer } from '@atlassian/jira-assets-app-page-config-container/src/ui/async.tsx';
import Spinner from '@atlassian/jira-common-components-spinner/src/view.tsx';
import { assetsDataManagerDataSourceEntryPoint } from '@atlassian/jira-spa-apps-assets-data-manager-data-source/entrypoint.tsx';

const assetsDataManagerDataSourcePageEntryPoint = createChromelessEntryPoint({
	main: assetsDataManagerDataSourceEntryPoint,
});

export const assetsDataManagerDataSourceRouteEntry = createEntry(
	assetsDataManagerDataSourceRoute,
	() => ({
		group: 'assets',
		LayoutOverrideComponent: AssetsLayout,
		PageConfigContainerOverride: AssetsPageConfigContainer,
		skeleton: Spinner,
		perfMetricKey: 'assets-data-manager-data-source',
		pageId: () => 'spa-apps/assets-data-manager-data-source',
		resources: getAssetsAppResources(),
		forPaint: [LazyAssetsLayout],

		entryPoint() {
			return fg('assets_data_manager_jira_spa')
				? assetsDataManagerDataSourcePageEntryPoint
				: undefined;
		},

		component: ErrorPagesNotFound,

		meta: {
			reporting: {
				id: APP_NAMES.ASSETS_APP_DATA_MANAGER_DATA_SOURCE_PAGE,
				packageName: toPackageName(APP_NAMES.ASSETS_APP_DATA_MANAGER_DATA_SOURCE_PAGE),
				teamName: 'Aurum',
			},
		},

		bifrost: {
			bifrostGroup: 'shell-only',

			bundling: {
				packageName:
					'@atlassian/jira-router-routes-assets-data-manager-entries/src/assetsDataManagerDataSourceRouteEntry.tsx',
				whichExportToUse: 'assetsDataManagerDataSourceRouteEntry',
			},

			enabled: true,
		},
	}),
);
